module.exports = __webpack_public_path__ + "static/media/back4.b1a4721f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/back4.jpg
// module id = 1198
// module chunks = 0